import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getNetworkState, NetworkError, networkInitialState, NetworkStatuses } from 'store/network';
import { ConfiguratorsListingState, RatingData, TSLPData } from './types';
import { sliceKey as name } from './utils';

const initialState: ConfiguratorsListingState = {
	data: {
		configurators: [],
		deadlines: null,
		isCompensationEnabled: false,
	},
	network: networkInitialState,
	rating: {
		data: [],
		network: networkInitialState,
	},
};

export const ConfiguratorsListingSlice = createSlice({
	name,
	initialState,
	reducers: {
		fetchConfiguratorsRequest(state) {
			state.network = getNetworkState(NetworkStatuses.REQUEST);
		},
		fetchConfiguratorsSuccess(state, action: PayloadAction<{ data: TSLPData }>) {
			const { data } = action.payload;
			state.data = data;
			state.network = getNetworkState(NetworkStatuses.SUCCESS);
		},
		fetchConfiguratorsFailed(state, action: PayloadAction<{ error: NetworkError }>) {
			const { error } = action.payload;
			state.network = getNetworkState(NetworkStatuses.FAILED, error);
		},
		fetchRatingRequest(state) {
			state.rating.network = getNetworkState(NetworkStatuses.REQUEST);
		},
		fetchRatingSuccess(state, action: PayloadAction<{ data: RatingData[] }>) {
			const { data } = action.payload;
			state.rating.data = data;
			state.rating.network = getNetworkState(NetworkStatuses.SUCCESS);
		},
		fetchRatingFailed(state, action: PayloadAction<{ error: NetworkError }>) {
			const { error } = action.payload;
			state.rating.network = getNetworkState(NetworkStatuses.FAILED, error);
			state.rating.data = [];
		},
	},
});

export const {
	actions: configuratorsListingActions,
	reducer: configuratorsListingReducer,
	name: configuratorsListingName,
} = ConfiguratorsListingSlice;

export const {
	fetchConfiguratorsRequest,
	fetchConfiguratorsFailed,
	fetchConfiguratorsSuccess,
	fetchRatingRequest,
	fetchRatingSuccess,
	fetchRatingFailed,
} = configuratorsListingActions;

export const configuratorsListingState = initialState;
